import { Avatar, Stack, Typography, MenuItem } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';
import { Subsidiary } from '@vy/types';
import { isNotEmptyArray, isNotEmptyString } from '@vy/utils';

export type VyAccountDropDownHeaderProps = {
  accountName: string;
  subsidiaries: Subsidiary[];
  logo?: string;
};

export const VyAccountDropDownHeader: React.FC<VyAccountDropDownHeaderProps> = ({
  accountName,
  subsidiaries,
  logo,
}) => {
  const hasLogo = isNotEmptyString(logo);

  return (
    <MenuItem
      disableRipple
      sx={{
        height: 'auto',
        backgroundColor: '#e6f2fc',
        '&:hover': {
          backgroundColor: '#e6f2fc',
        },
        px: 2,
        py: 1.5,
        cursor: 'default',
        borderRadius: '8px 8px 0 0',
      }}
    >
      <Stack direction="row" spacing={1.5} sx={{
        alignItems: "center"
      }}>
        <Avatar
          sx={{
            width: 24,
            height: 24,
            bgcolor: hasLogo ? 'transparent' : 'primary.dark',
          }}
        >
          {/* uncomment it when Shenhav wants it back */}
          {/* {hasLogo ? (
            <img src={logo} alt="Logo" style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
          ) : ( */}
          <VyIcon icon="AvatarAccount" strokeOpacity={1} color="#25F6E7" transform="scale(1.3)" />
          {/* )} */}
        </Avatar>
        <Stack direction="column" sx={{ width: 120 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              color: "#0C20A4",
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              lineHeight: '16px',
              wordBreak: 'break-word',
              maxHeight: '32px'
            }}>
            {accountName}
          </Typography>

          {isNotEmptyArray(subsidiaries) && (
            <Typography variant="caption" sx={{
              color: "#6B7A99"
            }}>
              Main company
            </Typography>
          )}
        </Stack>
      </Stack>
    </MenuItem>
  );
};
